// Package imports:
import React from 'react';
// Component imports:
import Entrypoint from '../Entrypoint';
// import CompanySubPage from '../../components/Company/CompanySubPage/CompanySubPage';
import ValuationComp from '../../components/Company/CompanyValuation/ValuationPage';
// Type imports:
import { ICompanyViewModel } from '../../types/CompanyTypes';

const Valuation: React.FC<ICompanyViewModel> = ({
    id,
    isAuthenticated,
    isSubscriber
}) => {
    return (
        <Entrypoint>
            <ValuationComp
                id={id}
                isAuthenticated={isAuthenticated}
                isSubscriber={isSubscriber}
            />
            {/* <CompanySubPage
                noAd
                id={id}
                title='Verðmat Keldunnar'
                isAuthenticated={isAuthenticated}
                isSubscriber={isSubscriber}
                component={
                    <ValuationComp id={id} isAuthenticated={isAuthenticated} isSubscriber={isSubscriber} />
                }
            /> */}
        </Entrypoint>
    );
}

export default Valuation;